// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import '@/scss'

import Vue from 'vue'
import { vuetify, i18n, axios } from '@/plugins-conf'
import '@/filters'
import store from '@/store'
import App from '@/App'
import router from '@/router'
import '@/shared/components/register-components'
import '@/shared/mixins/register-mixins'
import { AppConfigApi } from './shared/services/api'

window.axios = axios
window.store = store
window.i18n = i18n
window.router = router

Vue.config.productionTip = false

AppConfigApi.getAppInfo()
  .then(appInfo => {
    console.log('appInfo', appInfo)
    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App),
      beforeCreate () {

        this.$store.commit('main/setBuildTime', appInfo.buildTime)
        this.$store.commit('main/setAppVersion', appInfo.appVersion)
        this.$store.commit('main/setAppName', appInfo.appName)
        this.$store.commit('main/setCurrencies', appInfo.currencies)
        this.$store.commit('main/setCurrency', appInfo.currencies[0])
        this.$store.commit('main/setUiConf', appInfo.uiConf)
      }
    }).$mount('#app')
  })
  .catch(error => console.error("Error back office : ",error))
  .finally(() => {})





